export enum GenericEnum {
  Yes = 'Yes',
  No = 'No'
}
